import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, RefreshCw } from "lucide-react";
import SobrietyCounter from "@/components/SobrietyCounter";
import JournalSection from "@/components/JournalSection";
import { api } from "@/lib/api";

export default function CounterPage() {
  const [quote, setQuote] = useState("Chaque seconde compte. Reviens ici dès que tu as besoin de voir le chemin parcouru.");
  const [loading, setLoading] = useState(false);

  const refresh = async () => {
    try {
      setLoading(true);
      const r = await api.get("/motivation");
      setQuote(r.data.quote);
    } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <>
      <SobrietyCounter />

      {/* Affirmations positives */}
      <section className="py-10 lg:py-14">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div
            className="rounded-3xl border border-white/10 p-8 lg:p-10 text-center"
            style={{
              background:
                "radial-gradient(500px 300px at 15% 15%, rgba(16, 185, 129, 0.28), transparent 60%)," +
                "radial-gradient(500px 300px at 85% 85%, rgba(249, 115, 22, 0.22), transparent 60%)," +
                "linear-gradient(160deg, rgba(30, 41, 59, 0.9), rgba(11, 17, 32, 0.95))",
            }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs text-emerald-200 font-medium">
              <Sparkles className="w-3.5 h-3.5" /> Affirmation positive
            </div>
            <AnimatePresence mode="wait">
              <motion.p
                key={quote}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.35 }}
                className="mt-5 text-white font-[Outfit] font-bold text-2xl sm:text-3xl max-w-2xl mx-auto leading-snug"
                data-testid="counter-affirmation"
              >
                « {quote} »
              </motion.p>
            </AnimatePresence>
            <button
              onClick={refresh}
              disabled={loading}
              className="mt-6 inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold px-5 py-2.5 rounded-full"
            >
              <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
              Une autre
            </button>
          </div>
        </div>
      </section>

      <JournalSection />
    </>
  );
}
